import { createEntityAdapter } from '@reduxjs/toolkit'

import { Field } from 'common/fields/entities/field'

export const fieldsAdapter = createEntityAdapter<Field>()

export const initialState = fieldsAdapter.getInitialState({ fetching: false, initialized: false })

export type FieldsState = typeof initialState
